module.exports = __webpack_public_path__ + "img/video.f5bbd6a3.svg";